<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>No Authorizado</h2>
                </div>


            </div>
        </div>
    </div>
</div>

